import React, { PropTypes } from 'react'
import yaml from 'js-yaml'
import Helmet from 'react-helmet'
import { config } from 'config'
import Product from '../components/Product'

function YamlWrapper(props) {
	const {
		route: {
			pages,
			page
		}
	} = props

	return (
		<Product data={page.data} page={page} pages={pages} />
	)
}

YamlWrapper.propTypes = {
	route: React.PropTypes.object
}

YamlWrapper.defaultProps = {

}

export default YamlWrapper



// WEBPACK FOOTER //
// ../wrappers/yaml.js